import { render, staticRenderFns } from "./show-all.vue?vue&type=template&id=b22c5bfc&scoped=true&lang=pug&"
import script from "./show-all.vue?vue&type=script&lang=js&"
export * from "./show-all.vue?vue&type=script&lang=js&"
import style0 from "./show-all.vue?vue&type=style&index=0&id=b22c5bfc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22c5bfc",
  null
  
)

export default component.exports